import { FC } from "react";
import { ICON_VARIANTS } from "@miplatform/constants";
import Icon from "@mdi/react";
import { useTheme } from "@mui/material";

export const MiIcon: FC<IMiIconProps> = ({
  path,
  color,
  variant = ICON_VARIANTS.STANDARD,
  size = 1,
  style = {},
  disabled,
  ...rest
}) => {
  const theme = useTheme();

  if (!path) {
    return null;
  }

  if (variant === ICON_VARIANTS.CONTAINED) {
    return (
      <Icon
        path={path}
        size={size}
        color={theme.palette.common.white}
        style={{
          backgroundColor: color,
          padding: theme.spacing(size),
          borderRadius: theme.shape.borderRadius,
          ...(disabled ? { opacity: 0.5, cursor: "default" } : {}),
          ...style,
        }}
        {...rest}
      />
    );
  }

  if (variant === ICON_VARIANTS.OUTLINED) {
    return (
      <Icon
        path={path}
        size={size}
        color={color}
        style={{
          border: `1px solid ${color}`,
          padding: theme.spacing(size),
          borderRadius: theme.shape.borderRadius,
          ...(disabled ? { opacity: 0.5, cursor: "default" } : {}),
          ...style,
        }}
        {...rest}
      />
    );
  }

  return (
    <Icon
      path={path}
      color={color}
      size={size}
      style={{
        ...(disabled ? { opacity: 0.5, cursor: "default" } : {}),
        ...style,
      }}
      {...rest}
    />
  );
};

interface IMiIconProps extends React.HTMLAttributes<SVGElement> {
  path: string;
  color?: string;
  variant?: typeof ICON_VARIANTS;
  spin?: number;
  size?: number;
  style?: React.CSSProperties;
  disabled?: boolean;
}
